import { LICENSE_MODULES } from '../../../../constants';
import RPTRADE from './components/RPTRADE';
import II from './components/II';
import AVG from './components/AVG';
import TICKETS from './components/TICKETS';
import GMVA from './components/GMVA';

const coreMenu = {
  [LICENSE_MODULES.RPTRADE]: RPTRADE,
  [LICENSE_MODULES.AVG]: AVG,
  [LICENSE_MODULES.TICKETS]: TICKETS,
  [LICENSE_MODULES.GMVA]: GMVA,
  ...II
};

export default { coreMenu };
